import { Timer } from "lucide-react";
import { defineModuleUi } from "@vixio/data";
import { lazyPage } from "@vixio/ui";
import "./api";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const MeasurementPage = lazyPage(() => import("./StudiesPage"), "MeasurementPage");
const StudyPage = lazyPage(() => import("./StudyPage"), "StudyPage");

export default defineModuleUi({
  key: "measurement",
  title: "Medição de campo",
  domain: "diagnostics",
  icon: Timer,
  menu: [{ path: "/diagnostico/medicoes", label: "Medição de campo", minRole: "member", icon: Timer, order: 40, keywords: "etapa tempo mediana dispersão reaplicação autorização observação" }],
  routes: [
    { path: "/diagnostico/medicoes", element: <MeasurementPage />, minRole: "member" },
    { path: "/diagnostico/medicoes/:id", element: <StudyPage />, minRole: "member" },
  ],
});
